import { Avatar, Box, Grid, Typography } from '@mui/material';
import { fileUrl } from 'api/api';
import { selectMe } from 'app/slice/user.slice';
import ButtonCustom from 'component/Button/ButtonCustom';
import { colors } from 'constants/theme';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { routeName } from 'routes/routes-name';

/** TRANSLATION */
import { useTranslation } from 'react-i18next';

/** STYLE */
import axios from 'axios';
import { imgs } from 'constants/images';
import { menuSeconds } from 'constants/menus';
import { templateImage } from 'constants/theme';
import { Subtitle, Title } from 'features/page/style';
import _ from 'lodash';
import moment from 'moment';
import CheckboxButton from 'new-components/buttons/checkbox-button';
import AlertModal from 'new-components/modal/alert-modal';
import { useEffect, useState } from 'react';
import { getPermissionShortcuts, getSecureItem, removeSecureItem, setSecureItem } from 'utils/app.utils';
import { dateMonthToView } from 'utils/date.utils';


export default function Home() {
  const history = useHistory()
  const { t } = useTranslation()
  const user = useSelector(selectMe)
  const shortcutPermission = getPermissionShortcuts()
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [isUpdate, setIsUpdate] = useState(false)
  const [isOpenPopup, setIsOpenPopup] = useState(false)
  const [dataUpdate, setDataUpdate] = useState<any>({})
  const [time, setTime] = useState<any>('')
  const checkPermission = (key: string) => {
    return shortcutPermission ? _.includes(shortcutPermission, key) : false
  }
  const renderImage = (img: any) => {
    if (img) return `${fileUrl}/${img}`
    else return imgs.defaultAvatar
  }

  useEffect(() => {
    loadUpdateSystem()
  }, [])

  const loadUpdateSystem = async () => {
    // await axios.get(`${Config.URL_ALERT_UPDATE}/cliniter-last-version`).then((res) => {
    await axios.get(`https://manage.cliniterdental2.com/api/cliniter-last-version`).then((res) => {
      setDataUpdate(res.data)
      const data: any = res.data;
      const shortTimeStart: any = data?.start_time.split(':')
      const shortTimeEnd: any = data?.end_time.split(':')
      setTime(`${shortTimeStart[0]}.${shortTimeStart[1]} ${t('TIME_UNIT')} - ${shortTimeEnd[0]}.${shortTimeEnd[1]} ${t('TIME_UNIT')}`)
      const dateUpdate = data.start_date.split('-');
      const dateOne = moment([parseInt(dateUpdate[0]), parseInt(dateUpdate[1]), parseInt(dateUpdate[2])]);
      const dateTwo = moment([moment().year(), moment().month() + 1, moment().date()]);
      const result = dateOne.diff(dateTwo, 'days');
      if (result <= 0 && result >= -1 && getSecureItem('SHOW_POPUP') !== '1') {
        setIsOpenAlertModal(true)
        setIsUpdate(true)
        return;
      }

      if ((getSecureItem('SHOW_POPUP') !== '1') && (result >= 0 && result <= 5)) {
        setIsOpenAlertModal(true)
        setIsUpdate(false)
      } else if (result < -2) {
        removeSecureItem('SHOW_POPUP')
      }
    })
  }



  return (
    <div className='h-100 p-3'>
      <Grid container className='h-100' justifyContent={'center'}>
        <Grid item lg={6} xl={5} className='w-100 d-flex align-items-center justify-content-center d-none d-xl-flex'>
          <img src={templateImage.welcome} alt="" style={{ maxWidth: '100%' }} />
        </Grid>
        <Grid item lg={6} xl={5} className='w-100 d-flex flex-column align-items-center justify-content-xl-center mt-5 mt-xl-0'>
          <Avatar alt="Profile" src={renderImage(user?.profile?.fullpath)} className={'w-100 h-100'} sx={{ maxWidth: '146px', maxHeight: '146px', backgroundColor: colors.white, border: `1px solid ${colors.lightGray}`, borderRadius: '100px' }}>
            <img src={imgs.defaultAvatar} className="w-100 h-100" alt="" />
          </Avatar>
          <Box>
            <Title>{user?.fullname ? t('WELCOME', { full_name: user?.fullname }) : ''}</Title>
            <Subtitle>{t('WELCOME_DESCRIPTION', { clinic: t('CLINIC_TYPE') })}</Subtitle>
          </Box>
          {checkPermission(menuSeconds.HOME.key) && <Box className='w-100 mx-auto mt-5 mt-sm-4' sx={{ maxWidth: '300px' }}>
            <ButtonCustom textButton={t('BUTTON.GO_TO_HOME')} onClick={() => history.push(routeName.home)} className={'w-100'} />
          </Box>}
        </Grid>
      </Grid>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`${'แจ้งการอัปเดตระบบ'}`)}
        type={`${isUpdate ? 'success' : 'warning'}`}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.ENTER') }}
        onSubmit={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.SUBMIT') }}
        onCloseSubmit={true}
      >
        <>
          <Box>
            {!isUpdate && <Box display="flex" justifyContent="center" flexDirection='column' gap="16px" textAlign="center">
              <Box>
                <Typography fontSize='12px'>{t(`ขอแจ้งอัปเดตระบบ Cliniter Dental`)}</Typography>
                <Typography fontSize='12px' >{t(`เพื่อเพิ่มประสิทธิภาพในการให้บริการลูกค้า`)}</Typography>
              </Box>
              <Box>
                <Typography fontSize='12px'>{t(`วันที่`)} {dateMonthToView(new Date(dataUpdate.start_date), true)}</Typography>
                <Typography fontSize='12px'>{t(`ระหว่างเวลา`)} {time}</Typography>
              </Box>
            </Box>}
            <Box paddingY={'16px'}>
              <Box>
                <Typography fontSize='12px' fontWeight='600' alignItems='center'>{t(`ฟังก์ชันใหม่`)}</Typography>
                <div style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: dataUpdate.fn_new }} />
              </Box>
              <Box>
                <Typography fontSize='12px' fontWeight='600' alignItems='center'>{t(`การปรับปรุงฟังก์ชันการใช้งาน`)}</Typography>
                <div style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: dataUpdate.fn_update }} />
              </Box>
              <Box>
                <Typography fontSize='12px' fontWeight='600' alignItems='center'>{t(`ฟังก์ชันที่ได้รับการแก้ไข`)}</Typography>
                <div style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: dataUpdate.fn_cr }} /> </Box>
            </Box>
          </Box>
          <Box gap="16px">
            <CheckboxButton onChange={(e) => {
              setIsOpenPopup(e?.target?.checked)
              setSecureItem('SHOW_POPUP', `${e?.target?.checked ? '1' : '0'}`)
            }} label={t('ไม่แสดง Popup')} disabled={false} checked={isOpenPopup} inputProps={{ fontSize: '14px' }} />
          </Box>
        </>
      </AlertModal>
    </div>
  )
}
